module.exports = __webpack_public_path__ + "fb6210739c4993c1a86f812e6502e471.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Roboto/Roboto-Bold.ttf
// module id = 373
// module chunks = 0